export const DEFAULT_SITE_SKIN = "xitong";
